import React from 'react'

export default function FaceFeature({ scaleX, fill, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} fill="none">
      <path
        d="M50.7501 15.2617C49.8001 12.8217 48.5001 10.9418 47.1201 9.48175C45.5501 7.83175 40.1901 1.55176 26.4901 1.55176C18.0701 1.55176 16.4201 4.69176 16.4201 4.69176C16.4201 4.69176 7.96007 6.06175 4.37007 15.2617C1.40007 22.8617 0.740073 38.7118 4.37007 47.7918C4.37007 47.7918 6.35005 36.7318 6.35005 29.1318C6.35005 21.5318 7.18008 12.7818 16.7501 7.50175L27.4801 14.9317C27.4801 14.9317 37.6301 8.16176 41.4301 9.97176C46.6901 11.3518 48.7801 22.6818 48.7801 29.1318C48.7801 36.7318 50.7601 47.7918 50.7601 47.7918C54.3801 38.7118 53.7201 22.8617 50.7501 15.2617Z"
        fill={fill}
        stroke={outline}
        strokeWidth="2"
        strokeMiterlimit="10"
      />
      <path
        d="M24.99 13.5617C24.99 13.5617 33.36 5.08171 43.27 6.18171"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M23.6699 12.3518C23.6699 12.3518 32.04 3.87175 41.95 4.97175"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M22.1301 11.2517C22.1301 11.2517 30.5001 2.77165 40.4101 3.87165"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M19.9302 10.1418C19.9302 10.1418 28.3002 1.66179 38.2102 2.76179"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M18.1602 9.3718C18.1602 9.3718 24.1502 3.30181 32.0002 2.10181"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M16.73 8.27187C16.73 8.27187 21.32 3.62186 27.74 1.65186"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M49.21 30.5117C49.21 30.5117 52.7299 31.7217 53.6099 35.6817"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M49.21 27.6519C49.21 27.6519 52.7299 28.8619 53.6099 32.8219"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M6.38 30.5117C6.38 30.5117 2.85998 31.7217 1.97998 35.6817"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
      <path
        d="M6.38 27.6519C6.38 27.6519 2.85998 28.8619 1.97998 32.8219"
        stroke={outline}
        strokeWidth="0.5"
        strokeMiterlimit="10"
      />
    </g>
  )
}
